

import Vue from 'vue'
import {namespace} from "vuex-class";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortLocation} from "@/model/shortInterfaces";
import {EOrderTypes, IOrder} from "@/model/Order/orderInterfaces";
import {UrlHelper} from "@/helpers/UrlHelper";
import CellChip from "@/components/shared/chips/CellChip.vue";
import OONewCellButton from "@/components/order/widget/OONewCellButton.vue";
import {IAuthUserData} from "@/store/modules/authModule";
import {PermissionHelper} from "@/helpers/PermissionHelper";
import {EUserPermissions} from "@/model/EUserPermissions";
import VueI18n from "vue-i18n";
import {IOnOffHandlers} from "bonomo/dist";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

const authModule = namespace("authModule");

@Component({
    name: 'OOLocation',
    components: {
      CellChip,
      OONewCellButton,
      SimpleConfirmationDialog,
    }
  })
  export default class OOLocation extends Vue {

    @Prop()
    protected order!: IOrder;

    @authModule.Getter('userData')
    protected authUser!: IAuthUserData;

    protected showDialog: boolean = false;
    protected submitting: boolean = false;
    private subscribes: IOnOffHandlers = {};

    private get hasTwoLocations(): boolean {
      const l1 = this.order.pickupLocation;
      const l2 = this.order.deliveryLocation;
      return l1 && l2 && (l1.type !== l2.type || l1.id !== l2.id);
    }

    private get hasTimeslots(): boolean {
      return this.isHomeDelivery;
    }

    private get showLockerCode(): boolean {
      return this.order.type !== EOrderTypes.home_delivery &&
          this.order.type !== EOrderTypes.office_order &&
          this.order.type !== EOrderTypes.professional_service;
    }
    protected get hasLockerCode(): boolean {
      return !!this.order.locker_code && !!this.order.locker_code.length;
    }

    private get isHomeDelivery(): boolean {
      return this.order.type == 'home_delivery';
    }

    private get location(): IShortLocation {
      return this.order ? (this.order.pickupLocation || this.order.deliveryLocation) : {} as IShortLocation;
    }
    private get isProfessionalServiceOrder(): boolean {
      return this.order.type === EOrderTypes.professional_service;
    }

    protected get canOpenCells() {
      const authUser = this.authUser;
      const communityId = this.order.deliveryLocation.community_id || 0;
      return (
        PermissionHelper.hasPermission(
          authUser,
          EUserPermissions.PERMISSION_INSTALLER,
          communityId
        ) ||
        PermissionHelper.hasPermission(
          authUser,
          EUserPermissions.PERMISSION_REMOTE_OPEN_CELLS,
          communityId
        ) ||
        this.canLockerFactory
      );
    }

    protected get canLockerFactory() {
      const authUser = this.authUser;
      return PermissionHelper.hasPermission(
        authUser,
        EUserPermissions.PERMISSION_LOCKER_FACTORY,
        1
      );
    }
    // probably these would go better with moment
    private formatDate(dateString: string) {
      const date = new Date(dateString);
      return date.toLocaleString('default', {day: 'numeric'}) + ' ' +
        date.toLocaleString('default', {month: 'short'}).toLocaleLowerCase();
    }
    private formatTimeslot(dateString: string) {
      const date = new Date(dateString);
      return '' +
        ('' + date.getHours()).padStart(2, '0') + ':' +
        ('' + date.getMinutes()).padStart(2, '0') +
        '-' +
        ('' + (date.getHours() + 1)).padStart(2, '0') + ':' +
        ('' + date.getMinutes()).padStart(2, '0');

    }

    protected onCardClicked() {
      if (this.hasTwoLocations) {
        return;
      }
      else if (this.order.pickupLocation.type == 'locker') {
        this.$router.push(UrlHelper.mayorLocker(this.order.pickupLocation.id));
      }
    }

    protected onLocationClicked(location: IShortLocation) {
      if (location.type == 'locker') {
        this.$router.push(UrlHelper.mayorLocker(location.id));
      }
    }

    protected openRemoteCell() {
      this.showDialog = true;
    }

    protected onOpenCellBtn() {
      if (this.order.deliveryCell) {
        this.$store.dispatch("lockerModule/openCell", {
          lockerId: this.order.deliveryLocation.id,
          cellId: this.order.deliveryCell.id,
        });
      } else if (this.order.pickupCell) {
        this.$store.dispatch("lockerModule/openCell", {
          lockerId: this.order.pickupLocation.id,
          cellId: this.order.pickupCell.id,
        });
      }
      this.submitting = true;
    }

    protected created() {
      this.subscribes = this.$ons({
        "backend.call.OK.cellOpened": this.onCellOpenedOK,
        "backend.call.KO.cellOpened": this.onCellOpenedKO,
      });
    }

    protected beforeDestroy() {
      this.$offs(this.subscribes);
    }

    protected onCellOpenedOK() {
      this.$uiBus.emit("success", "OK");
      this.showDialog = false;
      this.submitting = false;
    }

    protected onCellOpenedKO() {
      this.$uiBus.emit("errors", "KO");
      this.submitting = false;
    }

}

